import React, { FC, ReactElement } from 'react'
import { InsightsDTO } from '../../../../React/InsightsHub/Types/Types'
import { InsightsQuickInfo } from './InsightsQuickInfo'
import { InsightsHighlightInfo } from './InsightsHighlightInfo'

type Props = {
    insightsData: Nullable<InsightsDTO>
}

export const InsightsInformation: FC<Props> = ({ insightsData }: Props): ReactElement => (
    <div className='id-stats id-insights-information'>
        <InsightsQuickInfo quickInfo={insightsData?.QuickInfo} />
        <InsightsHighlightInfo highlightInfo={insightsData?.HighlightInfo} />
    </div>
)
